"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseCookiesToUser = exports.hasAuthCookie = exports.getDomain = exports.clearListCookies = void 0;
var _reactCookies = _interopRequireDefault(require("react-cookies"));
var _jwtDecode = _interopRequireDefault(require("jwt-decode"));
var _constants = require("../containers/constants");
var cookieDomain = process.env.COOKIE_DOMAIN;
var defaultCookieDomain = process.env.API_DOMAIN;
var getDomain = function getDomain() {
  var domain = cookieDomain || defaultCookieDomain;
  return domain ? ".".concat(domain) : "";
};
exports.getDomain = getDomain;
var hasAuthCookie = function hasAuthCookie() {
  return !!(document && document.cookie && document.cookie.indexOf(_constants.JWT_AUTH) >= 0);
};
exports.hasAuthCookie = hasAuthCookie;
var parseCookiesToUser = function parseCookiesToUser() {
  var loadedCookie = _reactCookies.default.load(_constants.JWT_AUTH);
  var user = null;
  if (loadedCookie) {
    user = (0, _jwtDecode.default)(loadedCookie);
  }
  return user;
};
exports.parseCookiesToUser = parseCookiesToUser;
var clearCookie = function clearCookie(name, domain) {
  return document.cookie = "".concat(name, "=;expires=Thu,01-Jan-70 00:00:01 GMT;domain=").concat(domain, ";path=/");
};
var clearListCookies = function clearListCookies(domain) {
  var cookies = document.cookie.split("; ");
  cookies.forEach(function (item) {
    clearCookie(item.split("=")[0], domain, "/");
  });
};
exports.clearListCookies = clearListCookies;